import { atom } from 'recoil'

import type { ModalRecipientTrackingState } from 'Pages/RecipientsList/model'

export const modalRecipientTrackingState = atom<ModalRecipientTrackingState>({
  key: 'recipientsList_modalRecipientTrackingState',
  default: {
    show: false,
    idRecipient: 0,
    tracking: false,
  },
})
